import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Contact form submission
export const submitContactForm = async (data) => {
  const response = await apiClient.post('/contact', data);
  return response.data;
};

// Newsletter subscription
export const subscribeNewsletter = async (email) => {
  const response = await apiClient.post('/newsletter', { email });
  return response.data;
};

// Career application
export const submitCareerApplication = async (data) => {
  const response = await apiClient.post('/careers/apply', data);
  return response.data;
};

// Partner application
export const submitPartnerApplication = async (data) => {
  const response = await apiClient.post('/partners/apply', data);
  return response.data;
};

// Health check
export const checkHealth = async () => {
  const response = await apiClient.get('/health');
  return response.data;
};

export default apiClient;
